import { render } from "./OurBusinessENG.vue?vue&type=template&id=afb8d0c4&scoped=true"
import script from "./OurBusinessENG.vue?vue&type=script&lang=js"
export * from "./OurBusinessENG.vue?vue&type=script&lang=js"

import "./OurBusinessENG.vue?vue&type=style&index=0&id=afb8d0c4&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb8d0c4"]])

export default __exports__